/* 店面 P0：导航真实展示及集合列表、筛选状态；不处理结算或订单。 */
(function () {
  'use strict';
  var api = window.__ga4Journey;
  if (!api) return;
  var menus = new Map(), navSeen = new WeakMap(), lists = new Map(), cards = new WeakMap();
  var ranges = new Map(), filterGroups = new WeakMap(), nativePanelOpen = null;
  var menuSelector = '.custom-mega, .ch-drawer, .ch-drawer__sub, .site-nav__details';
  function surface(el) {
    return el.closest('.ch-drawer') ? 'mobile_drawer' : (el.closest('.custom-mega') ? 'desktop_mega' : 'desktop_header');
  }
  function menuFor(el) {
    var menu = el.closest(menuSelector);
    return menu && menu.matches('details') && el.matches('summary') ? menu.parentElement.closest(menuSelector) : menu;
  }
  function displayed(el) {
    if (!el.isConnected || !el.getClientRects().length) return false;
    for (var node = el; node && node.nodeType === 1; node = node.parentElement) {
      var style = getComputedStyle(node);
      if (node.hidden || node.inert || node.getAttribute('aria-hidden') === 'true' || style.visibility === 'hidden' ||
        style.visibility === 'collapse' || style.display === 'none' || Number(style.opacity) === 0) return false;
    }
    return true;
  }
  function menuFields(el, state) {
    return { navigation_surface: surface(el), nav_item_id: el.dataset.navParentId || el.id || 'header_menu', menu_open_id: state.id };
  }
  function stopMenu(el, state, reason) {
    if (state.start === null) return;
    api.emit('nav_menu_dwell', Object.assign(menuFields(el, state), { dwell_time_ms: Math.round(performance.now() - state.start), dwell_end_reason: reason }));
    state.start = null;
  }
  function syncMenuDwell(el, state) {
    var visible = state.open && api.isAllowed() && document.visibilityState !== 'hidden' && state.inView && displayed(el);
    if (visible && state.start === null) state.start = performance.now();
    else if (!visible) stopMenu(el, state, document.visibilityState === 'hidden' ? 'hidden' : 'visibility_changed');
  }
  function syncMenus() {
    document.querySelectorAll(menuSelector).forEach(function (el) {
      var state = menus.get(el);
      if (!state) {
        state = { id: '', open: false, start: null, inView: false }; menus.set(el, state);
        if (menuObserver) menuObserver.observe(el);
      }
      var open = el.matches('details') ? el.open : el.classList.contains('is-open');
      // 子抽屉必须同时有打开的父抽屉。
      var parent = el.parentElement && el.parentElement.closest(menuSelector);
      if (parent && !parent.matches('details') && !parent.classList.contains('is-open')) open = false;
      if (open && !state.open && api.isAllowed()) {
        state.id = api.uuid(); state.open = true;
        api.emit('nav_menu_opened', menuFields(el, state));
      }
      if (!open && state.open) {
        stopMenu(el, state, 'closed');
        api.emit('nav_menu_closed', menuFields(el, state)); state.open = false;
      }
      syncMenuDwell(el, state);
    });
  }
  function navFields(el) {
    var menu = menuFor(el), state = menu && menus.get(menu);
    var parent = el.closest('[data-nav-parent-id]');
    // 移动顶层使用 div 列表，不能把每个 ch-drawer__item 当成独立列表。
    var group = el.closest('ul, ol, [role="list"], .custom-mega__links, .ch-drawer__body') || parent || el.parentElement;
    var siblings = Array.from(group.querySelectorAll('[data-nav-item-id]')).filter(function (candidate) {
      return menuFor(candidate) === menu && candidate.closest('[data-nav-parent-id]') === parent;
    });
    var href = el.getAttribute('href') || '';
    return {
      nav_item_id: el.dataset.navItemId,
      nav_item_name: el.dataset.navItemName || 'unnamed',
      nav_parent_id: parent ? parent.dataset.navParentId : 'root',
      nav_level: el.closest('.site-nav__deep-dropdown') ? 3 : (el.closest('.custom-mega, .ch-drawer__sub, .site-nav__dropdown') ? 2 : 1),
      nav_position: siblings.indexOf(el) + 1,
      navigation_surface: surface(el), menu_open_id: state && state.open ? state.id : 'header',
      destination_type: /\/collections\//.test(href) ? 'collection' : (/\/products\//.test(href) ? 'product' : 'other')
    };
  }
  function collectionFields(root, state) {
    var params = new URLSearchParams(location.search);
    return { collection_handle: root.dataset.collectionHandle || 'unknown', collection_id: root.dataset.collectionId || 'unknown',
      product_count: Number(root.dataset.productCount) || 0, sort_by: params.get('sort_by') || 'default', list_instance_id: state.id, filter_state_id: state.filterId };
  }
  function item(card) {
    var root = card.closest('[data-ph-collection-grid], [data-ga4-collection-grid]');
    var position = Number(card.dataset.listPosition) || (root ? Array.from(root.querySelectorAll('[data-ga4-product-card]')).indexOf(card) + 1 : 1);
    var pagination = root && root.querySelector('[data-ga4-page-number]');
    var pageNumber = Number(card.dataset.pageNumber) || (pagination && Number(pagination.dataset.ga4PageNumber)) || Number(new URLSearchParams(location.search).get('page')) || 1;
    var pageSize = pagination && Number(pagination.dataset.ga4PageSize);
    var result = { item_id: card.dataset.productId, item_name: card.dataset.productTitle || card.dataset.ga4Title || 'unnamed',
      item_list_id: 'collection_grid', index: position,
      price: Number(card.dataset.price === undefined ? card.dataset.ga4Price : card.dataset.price) / 100, quantity: 1, product_handle: card.dataset.productHandle || 'unknown',
      page_number: pageNumber };
    var absolute = Number(card.dataset.absolutePosition) || (pageNumber === 1 ? position : (pageSize ? (pageNumber - 1) * pageSize + position : 0));
    if (absolute > 0) result.absolute_position = absolute;
    return result;
  }
  function productEvent(name, card) {
    var root = card.closest('[data-ph-collection-grid], [data-ga4-collection-grid]'), state = root && lists.get(root);
    if (!state) return false;
    var currency = root.dataset.currency || (window.__ga4JourneyConfig || {}).currency;
    if (!currency) { api.noteSkipped(name, 'missing_currency'); return false; }
    return api.emit(name, Object.assign(collectionFields(root, state), { item_list_id: 'collection_grid', currency: currency, items: [item(card)] }));
  }
  function listSignature(root) {
    return [root.dataset.collectionId, root.dataset.productCount, root.dataset.currentTags, location.search,
      Array.from(root.querySelectorAll('[data-ph-product-card], [data-ga4-product-card]')).map(function (card) { return [card.dataset.productId, card.dataset.listPosition, card.dataset.price || card.dataset.ga4Price, card.dataset.productTitle || card.dataset.ga4Title].join(':'); }).join('|')].join(';');
  }
  function createList(root, updated) {
    var state = { id: api.uuid(), filterId: api.uuid(), seen: new Set(), signature: listSignature(root) };
    lists.set(root, state);
    api.emit(updated ? 'collection_results_updated' : 'collection_viewed', collectionFields(root, state));
    var filters = [];
    new URLSearchParams(location.search).forEach(function (value, key) { if (key.indexOf('filter.') === 0) filters.push({ name: key, value: value }); });
    try { JSON.parse(root.dataset.currentTags || '[]').forEach(function (tag) { filters.push({ name: 'tag', value: tag }); }); } catch (_) {}
    filters.forEach(function (filter, index) {
      api.emit('collection_filter_state', Object.assign(collectionFields(root, state), { filter_name: filter.name, filter_value: filter.value, state_index: index + 1, state_count: filters.length }));
    });
    root.querySelectorAll('[data-ph-product-card], [data-ga4-product-card]').forEach(function (card) { cards.set(card, root); if (observer) observer.observe(card); });
  }
  // 打开状态不代表在屏幕内；独立观察菜单，避免隐藏祖先和滑出面板继续累计时长。
  var menuObserver = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = menus.get(entry.target);
      if (!state) return;
      var rect = entry.boundingClientRect, visible = entry.intersectionRect;
      var required = Math.min(rect.height, window.innerHeight) * Math.min(rect.width, window.innerWidth) * 0.5;
      state.inView = entry.isIntersecting && required > 0 && visible.width * visible.height >= required;
      syncMenuDwell(entry.target, state);
    });
  }, { threshold: Array.from({ length: 101 }, function (_, i) { return i / 100; }) });
  var observer = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || !api.isAllowed() || document.visibilityState === 'hidden' || !displayed(entry.target)) return;
      var el = entry.target;
      if (el.matches('[data-nav-item-id]')) {
        var menu = menuFor(el), state = menu && menus.get(menu);
        if (menu && (!state || !state.open)) return;
        var fields = navFields(el), key = fields.menu_open_id;
        if (navSeen.get(el) !== key && api.emit('nav_item_impression', fields)) navSeen.set(el, key);
      } else {
        var root = cards.get(el), list = root && lists.get(root);
        var productKey = el.dataset.productId + ':' + el.dataset.listPosition;
        if (list && !list.seen.has(productKey) && productEvent('view_item_list', el)) list.seen.add(productKey);
      }
    });
  }, { threshold: [0, 0.5, 1] });
  function refreshExposure() {
    if (!observer) return;
    document.querySelectorAll('[data-nav-item-id], [data-ph-product-card], [data-ga4-collection-grid] [data-ga4-product-card]').forEach(function (el) { observer.unobserve(el); observer.observe(el); });
  }
  function scan() {
    syncMenus();
    document.querySelectorAll('[data-ph-collection-grid], [data-ga4-collection-grid]').forEach(function (root) {
      var state = lists.get(root);
      if (!state || state.signature !== listSignature(root)) createList(root, !!state || lists.size > 0);
    });
    lists.forEach(function (_, root) { if (!root.isConnected) lists.delete(root); });
    menus.forEach(function (state, el) {
      if (!el.isConnected) { stopMenu(el, state, 'removed'); if (menuObserver) menuObserver.unobserve(el); menus.delete(el); }
    });
    syncNativeFilters();
    refreshExposure();
  }
  document.addEventListener('click', function (event) {
    var el = event.target.closest && event.target.closest('[data-nav-item-id]');
    if (el) api.emit('nav_item_click', navFields(el));
    var card = event.target.closest && event.target.closest('[data-ph-product-card], [data-ga4-product-card]');
    if (card && !event.target.closest('button, input, select')) productEvent('select_item', card);
    var link = event.target.closest && event.target.closest('.cg-pagination a, .pagination a, .cg-tab[href], [data-ph-collection-image-nav] a[href]');
    if (!link) return;
    var root = document.querySelector('[data-ph-collection-grid], [data-ga4-collection-grid]'), state = root && lists.get(root);
    if (!state) return;
    var url = new URL(link.href, location.origin), fields = Object.assign(collectionFields(root, state), { operation_id: api.uuid() });
    if (link.closest('.cg-pagination, .pagination')) api.emit('collection_pagination_clicked', Object.assign(fields, { from_page: Number(new URLSearchParams(location.search).get('page')) || 1, to_page: Number(url.searchParams.get('page')) || 1 }));
    else api.emit('collection_subcategory_clicked', Object.assign(fields, { content_name: link.getAttribute('data-ph-content-name') || link.textContent.trim(), destination_path: url.pathname }));
  }, true);
  function collectionContext() {
    var root = document.querySelector('[data-ph-collection-grid], [data-ga4-collection-grid]'), state = root && lists.get(root);
    return state && collectionFields(root, state);
  }
  function syncNativeFilters() {
    // 原生价格滑块通过 noUiSlider 回调提交，不会触发 input 的 DOM change。
    ranges.forEach(function (slider, element) {
      if (!element.isConnected || element.noUiSlider !== slider) { slider.off('change.ga4Journey'); ranges.delete(element); }
    });
    document.querySelectorAll('.price-range__slider').forEach(function (element) {
      if (!element.noUiSlider || ranges.has(element)) return;
      var slider = element.noUiSlider;
      ranges.set(element, slider);
      slider.on('change.ga4Journey', function (values) {
        var fields = collectionContext(), min = Number(values[0]), max = Number(values[1]);
        if (!api.isAllowed() || !element.isConnected || !fields || !isFinite(min) || !isFinite(max)) return;
        api.emit('collection_filter_changed', Object.assign({}, fields, { action: 'price_apply', filter_name: 'price', price_min: min, price_max: max, is_selected: true, operation_id: api.uuid() }));
      });
    });
    var fields = collectionContext(), drawer = document.getElementById('FilterDrawer');
    if (!fields) return;
    if (drawer) {
      var open = drawer.classList.contains('drawer--is-open') && !drawer.inert && drawer.getAttribute('aria-hidden') !== 'true';
      if (api.isAllowed() && nativePanelOpen !== null && open !== nativePanelOpen) api.emit('collection_filter_panel_interaction', Object.assign({}, fields, { action: open ? 'open' : 'close', close_method: 'native_drawer', operation_id: api.uuid() }));
      nativePanelOpen = open;
    }
    document.querySelectorAll('#CollectionSidebar .collapsible-trigger[aria-expanded], #FilterDrawer .collapsible-trigger[aria-expanded]').forEach(function (button) {
      var open = button.getAttribute('aria-expanded') === 'true', previous = filterGroups.get(button);
      if (api.isAllowed() && previous !== undefined && previous !== open) api.emit('collection_filter_panel_interaction', Object.assign({}, fields, { action: open ? 'filter_group_open' : 'filter_group_close', filter_name: button.textContent.trim(), operation_id: api.uuid() }));
      filterGroups.set(button, open);
    });
  }
  // 初始化可能晚于模块；交互捕获阶段只绑定现有滑块，不修改其值或提交行为。
  document.addEventListener('pointerdown', syncNativeFilters, true);
  document.addEventListener('keydown', syncNativeFilters, true);
  document.addEventListener('click', function (event) {
    if (!api.isAllowed()) return;
    var fields = collectionContext(), target = event.target;
    if (!fields || !target.closest) return;
    var clear = target.closest('.cg-clear-filters[href]');
    if (clear) api.emit('collection_filter_changed', Object.assign({}, fields, { action: 'clear', filter_name: 'all', filter_value: '', is_selected: false, operation_id: api.uuid() }));
    var remove = target.closest('.tag--remove a[href]');
    if (remove) {
      var after = new URL(remove.href, location.origin).searchParams, before = new URLSearchParams(location.search), operation = api.uuid();
      before.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0 && after.getAll(key).indexOf(value) < 0) api.emit('collection_filter_changed', Object.assign({}, fields, { action: 'remove_apply', filter_name: key, filter_value: value, is_selected: false, operation_id: operation }));
      });
    }
    var panel = target.closest('[data-cg-open-filters], [data-cg-close-filters], .cg-filters-drawer button[type="submit"]');
    if (panel) api.emit('collection_filter_panel_interaction', Object.assign({}, fields, {
      action: panel.matches('[data-cg-open-filters]') ? 'open' : (panel.matches('[type="submit"]') ? 'apply' : 'close'),
      close_method: panel.matches('.cg-filters-drawer-overlay') ? 'overlay' : 'button', operation_id: api.uuid()
    }));
    var link = target.closest('.richtextfornewdesign a[href], [id^="FeatureRowsStatic-"] a[href], [id^="BrandStory-"] a[href], [id^="FaqStatic-"] a[href], .breadcrumb a[href], .gift-sale-banner a[href]');
    if (link) {
      var url = new URL(link.href, location.origin);
      if (/^https?:$/.test(url.protocol)) api.emit('collection_content_clicked', Object.assign({}, fields, {
        component_id: (link.closest('[id]') || {}).id || 'collection_content', content_name: link.textContent.trim(), destination_path: url.pathname
      }));
    }
    var dot = target.closest('[data-fc-dot]');
    if (dot) {
      var active = dot.parentElement.querySelector('[data-fc-dot].is-active');
      api.emit('collection_carousel_navigated', Object.assign({}, fields, { component_id: (dot.closest('[id]') || {}).id || 'feature_cards', from_position: active ? Number(active.dataset.fcDot) + 1 : 0, to_position: Number(dot.dataset.fcDot) + 1 }));
    }
  }, true);
  document.addEventListener('change', function (event) {
    if (!api.isAllowed() || !event.target.matches('[data-cg-range-min], [data-cg-range-max]')) return;
    var fields = collectionContext(), slider = event.target.closest('[data-cg-price-slider]');
    if (!fields || !slider) return;
    var min = slider.querySelector('[data-cg-range-min]'), max = slider.querySelector('[data-cg-range-max]');
    if (!min || !max) return;
    api.emit('collection_filter_changed', Object.assign({}, fields, { action: event.target.closest('[data-cg-filters-drawer]') ? 'price_pending' : 'price_apply', filter_name: 'price', price_min: Number(min.value), price_max: Number(max.value), is_selected: true, operation_id: api.uuid() }));
  }, true);
  document.addEventListener('toggle', function (event) {
    if (!api.isAllowed() || !event.target.matches('details')) return;
    var fields = collectionContext(), el = event.target;
    if (!fields) return;
    if (el.matches('.cg-filter')) api.emit('collection_filter_panel_interaction', Object.assign({}, fields, { action: el.open ? 'filter_group_open' : 'filter_group_close', filter_name: (el.querySelector('summary') || el).textContent.trim(), operation_id: api.uuid() }));
    var faq = el.closest('[id^="FaqStatic-"]');
    if (faq) api.emit('collection_faq_toggled', Object.assign({}, fields, { component_id: faq.id, question_position: Array.from(faq.querySelectorAll('details')).indexOf(el) + 1, action: el.open ? 'open' : 'close' }));
  }, true);
  document.addEventListener('change', function (event) {
    var root = event.target.closest('[data-ph-collection-grid], [data-ga4-collection-grid]');
    if (!root && event.target.matches('[name^="filter."], select[name="sort_by"]')) root = document.querySelector('[data-ga4-collection-grid]');
    var state = root && lists.get(root);
    if (!state) return;
    var fields = Object.assign(collectionFields(root, state), { operation_id: api.uuid() });
    if (event.target.matches('.cg-sort-select, select[name="sort_by"]')) api.emit('collection_sort_changed', Object.assign(fields, { sort_from: fields.sort_by, sort_to: event.target.value }));
    if (event.target.matches('.cg-filter-option input[type="checkbox"], [name^="filter."][type="checkbox"]')) api.emit('collection_filter_changed', Object.assign(fields, { action: event.target.closest('[data-cg-filters-drawer]') ? 'select_pending' : 'select_apply', filter_name: event.target.name, filter_value: event.target.value, is_selected: event.target.checked }));
  }, true);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') menus.forEach(function (state, el) { stopMenu(el, state, 'hidden'); });
    else { syncMenus(); refreshExposure(); }
  });
  window.addEventListener('pagehide', function () { menus.forEach(function (state, el) { stopMenu(el, state, 'pagehide'); }); });
  window.addEventListener('pageshow', scan);
  document.addEventListener('transitionend', function (event) {
    if (event.target.matches && event.target.matches(menuSelector)) { syncMenus(); refreshExposure(); }
  });
  function resetPage() {
    if (menuObserver) menuObserver.disconnect();
    menus.clear(); lists.clear(); navSeen = new WeakMap(); filterGroups = new WeakMap(); nativePanelOpen = null; scan();
  }
  api.onConsent(resetPage);
  if (api.onPageView) api.onPageView(resetPage);
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; scan(); });
  }).observe(document.body, { subtree: true, childList: true, attributes: true,
    attributeFilter: ['class', 'style', 'open', 'hidden', 'inert', 'aria-hidden', 'aria-expanded', 'data-product-count'] });
  scan();
  if (api.registerModule) api.registerModule('storefront', function () {
    var open = 0, active = 0;
    menus.forEach(function (state) { if (state.open) open++; if (state.start !== null) active++; });
    return { menus: menus.size, openMenus: open, activeMenuDwell: active, lists: lists.size,
      markedNavItems: document.querySelectorAll('[data-nav-item-id]').length,
      markedProductCards: document.querySelectorAll('[data-ph-product-card], [data-ga4-product-card]').length,
      observerAvailable: !!observer };
  });
})();
